// Import Dependencies
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

@inject('responsiveStore')
@observer
export default class Responsive extends Component {
    updateBreakpoint = debounce(() => this.props.responsiveStore.updateBreakpoint(), 150);
    updateSize = throttle(() => this.props.responsiveStore.updateSize(), 150);

    componentDidMount() {
        const { responsiveStore, trackingBreakpoint, trackingSize } = this.props;

        responsiveStore.subscribe(trackingBreakpoint, trackingSize);
        if (trackingBreakpoint && responsiveStore.breakpointSubscribers === 1) {
            responsiveStore.updateBreakpoint();
            window.addEventListener('resize', this.updateBreakpoint);
        }
        if (trackingSize && responsiveStore.sizeSubscribers === 1) {
            responsiveStore.updateSize();
            window.addEventListener('resize', this.updateSize);
        }
    }

    componentWillUnmount() {
        const { responsiveStore, trackingBreakpoint, trackingSize } = this.props;

        this.props.responsiveStore.unsubscribe(trackingBreakpoint, trackingSize);
        if (trackingBreakpoint && responsiveStore.breakpointSubscribers === 0) {
            window.removeEventListener('resize', this.updateBreakpoint);
        }
        if (trackingSize && responsiveStore.sizeSubscribers === 0) {
            window.removeEventListener('resize', this.updateSize);
        }
    }

    render() {
        return this.props.children;
    }
}

Responsive.defaultProps = {
    trackingBreakpoint: false,
    trackingSize: false
};
